export const HELP_CENTRE_URL = 'https://www.admicity.co.uk/help-centre/';
